import {Component} from '@angular/core';
import {Button} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {HUMANIA_LINK} from '../../../utils/utility-constants';

@Component({
  selector: 'em-humania-section',
  templateUrl: './humania-section.component.html',
  imports: [CardModule, Button],
})
export class HumaniaSectionComponent {
  openHumaniaLink(): void {
    window.open(HUMANIA_LINK);
  }
}
